import qs from "qs";

/**
 * 获取地址参数对象
 * @return
 */
export const getQuery = () => {
  if (typeof window === "undefined") {
    return {};
  }
  return parseQueryString(window.location.search) as {
    [key: string]: any;
  };
};

export function stringifyQuery(params: { [key: string]: any }, sort = false) {
  return qs.stringify(
    params,
    sort ? { sort: (a, b) => a.localeCompare(b) } : undefined
  );
}

export function parseQueryString(query: string) {
  // Remove any leading '?' from the query string
  if (query.startsWith("?")) {
    query = query.slice(1);
  }
  return qs.parse(query);
}

/**
 * 获取指定的参数
 * @param key
 * @param defaultValue
 * @param query
 * @return
 */
export const getQueryParam = (key: string, defaultValue?: any, query?: any) => {
  const q = query || getQuery();
  return q[key] || defaultValue;
};

export const appendQueryParams = (params = {}) => {
  const url = new URL(window.location.href);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, value as string);
    }
  });

  const newUrl = url.toString();
  window.history.replaceState({}, "", newUrl);
};

export const deleteQueryParams = (keys: string[] | string) => {
  const url = new URL(window.location.href);

  const keyList = Array.isArray(keys) ? keys : [keys];
  keyList.forEach((key) => {
    url.searchParams.delete(key);
  });

  const newUrl = url.toString();
  window.history.replaceState({}, "", newUrl);
};
